import React from "react";

const Hud = () => (
  <span aria-hidden="true" className="hud-overlay">
    <span className="hud-c hud-tl" />
    <span className="hud-c hud-tr" />
    <span className="hud-c hud-bl" />
    <span className="hud-c hud-br" />
    <span className="holo-sheen" />
  </span>
);

export default Hud;
